import React, {ReactNode} from 'react';

export const JSXHelper = {
  renderComponentFromType: (component, props): ReactNode => {
    const Component = component;
    return <Component {...props} />;
  }
};